/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Utils')
    .directive('accTriggerClickOn', ['$document', function ($document) {
        var eventKeyCodeMap = {
            'enter': 13,
            'del': 46,
            'esc': 27,
        };
        return {
            scope: true,
            link: function($scope, $element, $attrs) {
                $document.on('keydown', function($event) {
                    if ($event.which == eventKeyCodeMap[$attrs['accTriggerClickOn']]) {
                        $element.click();
                    }
                })
            }
        }
    }]);